import './UploadThumbnailDialog.scss'

import axios from 'axios'
import Button from 'lib/components/Button/Button'
import Dialog from 'lib/components/Dialog/Dialog'
import AuthContext from 'lib/context/AuthContext'
import createYurl from 'lib/util/createYurl'
import { reportError } from 'lib/util/errorHandler'
import uploadToS3 from 'lib/util/uploadToS3'
import ActionDialog from 'pages/Home/admin/ActionDialog/ActionDialog'
import VideoType from 'pages/Home/VideoType'
import React, { useContext, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface UploadThumbnailDialogProps {
  onRequestClose: ()=> void
  video: VideoType
}

export default function UploadThumbnailDialog(props: UploadThumbnailDialogProps) {
  const { onRequestClose, video } = props
  const [t] = useTranslation()
  const fileInput = useRef(null)
  const [apiState, setApiState] = useState({ saving: false, error: null })
  const [thumbnailFile, setThumbnailFile] = useState(null)
  const { getAccessToken } = useContext(AuthContext)

  async function saveThumbnail() {
    setApiState({ saving: true, error: null })
    try {
      const accessToken = await getAccessToken()
      const headers = { Authorization: `Bearer ${accessToken}` }
      const { data: yurl } = await createYurl(
        thumbnailFile.name,
        {},
        accessToken,
        `${process.env.THREESIXTY_TRAINING_UPLOADS_S3_PREFIX}/${video.id}`,
        'public-read'
      )
      await uploadToS3(thumbnailFile, {}, yurl.url, yurl.type)
      const body = { thumbnailKey: yurl.key }
      await axios.post(`${process.env.THREESIXTY_TRAINING_URI}/admin/videos/${video.id}/thumbnail`, body, { headers })
      window.location.reload()
    } catch (err) {
      setApiState({ saving: null, error: t('admin.genericError') })
      reportError(err, 'Error uploading thumbnail for video', { videoId: video.id })
    }
  }

  function onSelectThumbnailClick() {
    if (fileInput && fileInput.current) {
      fileInput.current.click()
    }
  }

  return (
    <Dialog onRequestClose={onRequestClose}>
      <Dialog.Header onRequestClose={onRequestClose}>
        <Dialog.Title>
          {video.thumbnailKey
            ? t('home.videosSection.admin.uploadThumbnailDialog.replace')
            : t('home.videosSection.admin.uploadThumbnailDialog.upload')}
        </Dialog.Title>
      </Dialog.Header>
      <ActionDialog.Body className="upload-thumbnail-dialog__body">
        <Button variant="link" onClick={onSelectThumbnailClick}>
          {thumbnailFile ? thumbnailFile.name : t('home.videosSection.admin.uploadThumbnailDialog.selectFile')}
        </Button>
        <input
          type="file"
          ref={fileInput}
          onChange={e => setThumbnailFile(e.target.files[0])}
          style={{ display: 'none' }}
        />
      </ActionDialog.Body>
      <ActionDialog.Footer>
        <div>
          <ActionDialog.CancelButton onClick={onRequestClose} />
          <ActionDialog.SaveButton disabled={!thumbnailFile} loading={apiState.saving} onClick={saveThumbnail} />
        </div>
        <ActionDialog.Error message={apiState.error} />
      </ActionDialog.Footer>
    </Dialog>
  )
}
